import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getPollActvityOptions = async (activityId) => {
    const { data } = await vlqrApi.get(`/FocusGroupPollActivities/${activityId}/pollOptions`)
        .catch((error) => {
            handleError(error);
        });
    return data?.filter(x => !x.deletedOn);
};

const getPollActivityOptionsForCrossSessionActivity = async (crossSessionActivityId) => {
    const { data } = await vlqrApi.get(`/FocusGroupPollActivities/crossSession/${crossSessionActivityId}/pollOptions`)
        .catch((error) => {
            handleError(error);
        });

    // Exclude deleted sentiment/comments
    return data?.filter(x => !x.deletedOn);
};

const usePollOptionsForActivity = ({ activityId, crossSessionId }) => {
    const queryKey = [crossSessionId
        ? 'pollOptionsForCrossSessionActivity'
        : 'pollOptionsForActivity'];
    const queryKeyValue = crossSessionId ?? activityId;

    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: [queryKey, queryKeyValue],

        queryFn: () => crossSessionId
            ? getPollActivityOptionsForCrossSessionActivity(crossSessionId)
            : getPollActvityOptions(activityId)
    });

    return { data, refetch, isLoading, isError };
};

export default usePollOptionsForActivity;
